import * as React from 'react';

import { PromptConfirmation } from 'ui';
import { SharedState } from 'app/types-shared';
import { hasTranslationsLoaded, translationChanged } from 'app/infrastructure/translate/selectors';
import * as navigate from 'app/area/shared/navigation';

import { getTextConfigurationAccess } from '../../common/get-text-configuration-access';
import { TextConfigurationTranslation } from '../../constants';

interface ListWrapperProps {
  blockAccessTranslation: string;
  displayError: (errorMessage: string) => void;
  onContinue: (e: React.SyntheticEvent<any>) => void;
  onCancel: () => void;
  shouldDisplayModal: boolean;
  sharedState: SharedState;
  translation: TextConfigurationTranslation;
  children?: React.ReactNode;
}

export class ListWrapper
  extends React.PureComponent<ListWrapperProps> {

  public componentDidMount() {
    if (hasTranslationsLoaded(this.props.translation)) {
      this.initList();
    }
  }

  public componentDidUpdate(prevProps: ListWrapperProps) {
    if (translationChanged(this.props.translation, prevProps.translation)) {
      this.initList();
    }
  }

  private initList() {

    const { sharedState, displayError, blockAccessTranslation } = this.props;

    if (!getTextConfigurationAccess(sharedState)) {
      displayError(blockAccessTranslation);
      navigate.toStartupView(true);
    }
  }

  public render() {

    if (!getTextConfigurationAccess(this.props.sharedState)) {
      return null;
    }

    const { children, onContinue, onCancel, shouldDisplayModal, translation } = this.props;

    return <>
      {shouldDisplayModal
        ? <PromptConfirmation
          title={translation.cancel_changes}
          description={translation.are_you_sure}
          continueText={translation.undo_all}
          cancelText={translation.go_back}
          onContinue={onContinue}
          onCancel={onCancel}
        />
        : ''}
      {children}
    </>;
  }
}
